<p>
    The My Degree widget shows you how far along you are in meeting your degree and concentration requirements (if applicable), and allows you to download an unofficial report with a detailed analysis of your progress. If there are any questions about the information here or in your downloaded reports, please contact your program's helpdesk.
</p>
